const getTransitionDuration = function (_element, _ms = true) {
    return parseFloat(window.getComputedStyle(_element).transitionDuration) * (_ms ? 1000 : 1);
};

export default getTransitionDuration;
